import React, { useEffect, useState } from "react";
import useLostCustomers from "./store";
import CustomerTable from "./CustomerTable";
import MultipleBarGraph from "./GraphChart";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import SubTable from "./SubTable";
import CardTabs from "modules/common/card-tabs/CardTabs";
import CardDiv from "modules/common/card-div/CardDiv";
import EngageCustomer from "./EngageCustomer";
import {
  extractData,
  convertObjectForActiveTable,
  convertObjectForLostTable,
  convertActiveToObject,
  convertLostToObject,
} from "modules/utilities/utility";
import secureLocalStorage from "react-secure-storage";

function Customers() {
  const [lostCustomerGraph, setLostCustomerGraph] = useState();
  const [lostHeader, setLostHeader] = useState();
  const [activeHeader, setActiveHeader] = useState();
  const [activeCustomerGraph, setActiveCustomerGraph] = useState();
  const [lostSubTable, setLostSubTable] = useState();
  const [activeSubTable, setActiveSubTable] = useState();
  const medId = secureLocalStorage.getItem("id");
  const agentId = secureLocalStorage.getItem("agentId");

  const userId =
    agentId !== "undefined" && agentId !== "null" && agentId ? agentId : medId;
  const {
    fetchActiveCustomerData,
    fetchLostCustomerData,
    lostCustomerData,
    activeCustomerData,
  } = useLostCustomers();

  useEffect(() => {
    fetchActiveCustomerData(userId);
    fetchLostCustomerData(userId);
  }, [userId]);
  const lostDataFoEachTable = Object.values(lostCustomerData).map((data) => {
    return convertObjectForLostTable(data);
  });

  const activeDataForTable = Object.values(activeCustomerData).map((data) => {
    return convertObjectForActiveTable(data);
  });

  const lostCustomerGraphValues = Object.values(lostCustomerData).map((obj) => {
    return convertLostToObject(obj);
  });

  const activeCustomerGraphValues = Object.values(activeCustomerData).map(
    (obj) => {
      return convertActiveToObject(obj, "Active");
    }
  );

  const activeCustomerResult = extractData(activeCustomerData);
  const lostCustomerResult = extractData(lostCustomerData);

  const lostCustomerComponents = lostCustomerGraphValues[0]
    ? {
        table: (
          <SubTable
            data={lostSubTable || lostDataFoEachTable[0]}
            header={lostHeader}
          />
        ),
        graph: (
          <MultipleBarGraph
            header={lostHeader}
            data={lostCustomerGraph || lostCustomerGraphValues[0]}
          />
        ),
      }
    : {
        table: (
          <SubTable
            data={lostSubTable || lostDataFoEachTable[0]}
            header={lostHeader}
          />
        ),
        graph: <div>No graph</div>,
      };
  const activeCustomerComponents = activeCustomerGraphValues[0]
    ? {
        table: (
          <SubTable
            data={activeSubTable || activeDataForTable[0]}
            header={activeHeader}
          />
        ),
        graph: (
          <MultipleBarGraph
            header={activeHeader}
            data={activeCustomerGraph || activeCustomerGraphValues[0]}
          />
        ),
      }
    : {
        table: (
          <SubTable
            data={activeSubTable || activeDataForTable[0]}
            header={activeHeader}
          />
        ),
        graph: <div>No graph</div>,
      };
  return (
    <div className="d-flex flex-column gap-3">
      <Row>
        <Col md={6} xxl={7} className="ps-2">
          <CardDiv
            title={"Lost Customers"}
            component={
              <CustomerTable
                setGraph={setLostCustomerGraph}
                setSubTable={setLostSubTable}
                data={lostCustomerResult}
                dataForGraph={lostCustomerGraphValues}
                dataForTable={lostDataFoEachTable}
                headerLabel="Lost"
                setHeader={setLostHeader}
              />
            }
          />
        </Col>
        <Col md={6} xxl={5} className="ps-1">
          <CardTabs components={lostCustomerComponents} />
        </Col>
      </Row>

      <Row>
        <Col md={6} xxl={7} className="ps-2">
          <CardDiv
            title={"Active Customers"}
            component={
              <CustomerTable
                setGraph={setActiveCustomerGraph}
                setSubTable={setActiveSubTable}
                data={activeCustomerResult}
                dataForGraph={activeCustomerGraphValues}
                dataForTable={activeDataForTable}
                headerLabel="Active"
                setHeader={setActiveHeader}
              />
            }
          />
        </Col>
        <Col md={6} xxl={5} className="ps-2">
          <CardTabs components={activeCustomerComponents} />
        </Col>
      </Row>
      <Row className="ps-2 pe-3">
        <CardDiv component={<EngageCustomer />} title={"Engaged Customers"} />
      </Row>
    </div>
  );
}

export default Customers;
